import Header from "../../Layout/Header";
import { getdocument, stripeurl, updatedoc } from "../../service/Mainservice";
import Profilemenu from "./Profilemenu";
import { useEffect, useState } from "react";
import "./Earning.css";
import Loader from "../../Loader/Loader";
import KYCPopup from "./KYC";
import uploadimg from "../../assets/uploadimg.png";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";

const Documents = () => {
  const [load, setload] = useState(true);
  const [kyc, setkyc] = useState();
  const [url, seturl] = useState(false);
  const [error, seterror] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setsuccess] = useState(false);
  const [open2, setOpen2] = useState(false);

  const [preview, setpreview] = useState({
    dl: null,
    passport: null,
    certificate: null,
  });
  const [files, setFiles] = useState({
    dl: null,
    passport: null,
    certificate: null,
  });
  const { dl, passport, certificate } = preview;

  const [validerror, setvaliderror] = useState(null);

  const navigate = useNavigate();
  useEffect(() => {
    getdata();
    checkstripe();
  }, []);
  const checkstripe = async () => {
    const response = await stripeurl();
    console.log(response);
    if (response.data.url) {
      seturl(response.data.url);
      setkyc(true);
    }
  };

  const getdata = async (e) => {
    try {
      const response = await getdocument(e);
      console.log(response);
      setpreview({
        dl: process.env.REACT_APP_IMAGE_URL_DOC + response.data.data.dl_pic,
        passport:
          process.env.REACT_APP_IMAGE_URL_DOC +
          response.data.data.residence_or_passport_pic,
        certificate:
          process.env.REACT_APP_IMAGE_URL_DOC +
          response.data.data.cerification_pic,
      });
      setload(false);
    } catch (error) {
      console.log(error);
      setload(false);
    }
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    setFiles((prevFiles) => ({
      ...prevFiles,
      [type]: file,
    }));
    setpreview((prevFiles) => ({
      ...prevFiles,
      [type]: URL.createObjectURL(file),
    }));
  };

  const removeFile = (type) => {
    setFiles((prevFiles) => ({
      ...prevFiles,
      [type]: null,
    }));
    setpreview((prevFiles) => ({
      ...prevFiles,
      [type]: null,
    }));
  };

  const validate = () => {
    if (!dl) {
      setvaliderror("Please upload Driving license.");
    } else if (!passport) {
      setvaliderror("Please upload Permanent Resident/passport.");
    } else {
      setvaliderror(null);
      handlesubmit();
    }
  };

  const handlesubmit = async () => {
    setload(true);
    try {
      const response = await updatedoc(files);
      setFiles({
        preview: null,
        dl: null,
        passport: null,
        certificate: null,
      });
      setsuccess(response.data.message);
      setOpen(true);
      setload(false);
    } catch (error) {
      setload(false);
      seterror(error.message);
      setOpen2(true);
    }
  };

  return (
    <>
      <Header title="Earning/Stubs" headerbg="earningbg" />
      <div className="editprofile_data">
        <Profilemenu />
        <div className="editprofile_info">
          <h2 className="editprofile_maintitle">Documents</h2>

          {/* <h2>Upload Documents</h2> */}
          {/* <div className="Becomecare_profileimg">
            {preview ? (
              <div>
                <img
                  src={URL.createObjectURL(preview)}
                  className="Becomecareprofile_previewimg"
                />

                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  className="Becomecaredelete_img"
                  onClick={() => removeFile("preview")}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="11"
                    cy="11"
                    r="10.5"
                    fill="#FF3868"
                    stroke="white"
                  />
                  <path d="M15 7L7 15" stroke="white" stroke-linecap="round" />
                  <path d="M15 15L7 7" stroke="white" stroke-linecap="round" />
                </svg>
              </div>
            ) : (
              <label htmlFor="preview">
                <img src={editimg} alt="" className="Becomecareprofile_img" />
              </label>
            )}
            <input
              type="file"
              id="preview"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "preview")}
              name="profile_pic"
            />
          </div> */}
          <p className="Becomecare_uploadtitle">Driving License</p>
          <div className="Becomecare_uploadimg">
            {dl ? (
              <div className="Becomecareprofile_img">
                <img
                  src={dl}
                  alt="licence"
                  className="Becomecareprofile_img"
                  loading="lazy"
                />

                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  className="Becomecaredelete_img"
                  onClick={() => removeFile("dl")}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="11"
                    cy="11"
                    r="10.5"
                    fill="#FF3868"
                    stroke="white"
                  />
                  <path d="M15 7L7 15" stroke="white" stroke-linecap="round" />
                  <path d="M15 15L7 7" stroke="white" stroke-linecap="round" />
                </svg>
              </div>
            ) : (
              <div>
                <label htmlFor="dl">
                  <div className="becamecare_uploadbtn">
                    <img
                      src={uploadimg}
                      alt="liecence"
                      className="Becomecareprofile_img"
                      loading="lazy"
                    />
                    <p>
                      <span>Browse</span> or Drag and drop here
                    </p>
                  </div>
                </label>
                <input
                  type="file"
                  id="dl"
                  accept="image/*"
                  onChange={(e) => {
                    handleFileChange(e, "dl");
                    setvaliderror("");
                  }}
                  name="dl"
                />
              </div>
            )}
          </div>
          <p className="Becomecare_uploadtitle">
            Permanent Resident Or U.S. Passport
          </p>
          <div className="Becomecare_uploadimg">
            {passport ? (
              <div className="Becomecareprofile_img">
                <img
                  src={passport}
                  className="Becomecareprofile_img"
                  alt="passport"
                  loading="lazy"
                />

                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  className="Becomecaredelete_img"
                  onClick={() => removeFile("passport")}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="11"
                    cy="11"
                    r="10.5"
                    fill="#FF3868"
                    stroke="white"
                  />
                  <path d="M15 7L7 15" stroke="white" stroke-linecap="round" />
                  <path d="M15 15L7 7" stroke="white" stroke-linecap="round" />
                </svg>
              </div>
            ) : (
              <div>
                <label htmlFor="passport">
                  <div className="becamecare_uploadbtn">
                    <img
                      src={uploadimg}
                      alt="passport"
                      loading="lazy"
                      className="Becomecareprofile_img"
                    />
                    <p>
                      <span>Browse</span> or Drag and drop here
                    </p>
                  </div>
                </label>
                <input
                  type="file"
                  id="passport"
                  accept="image/*"
                  onChange={(e) => {
                    handleFileChange(e, "passport");
                    setvaliderror("");
                  }}
                  name="passport"
                />
              </div>
            )}
          </div>
          <p className="Becomecare_uploadtitle">Certifications</p>
          <div className="Becomecare_uploadimg">
            {certificate ? (
              <div className="Becomecareprofile_img">
                <img
                  src={certificate}
                  className="Becomecareprofile_img"
                  alt="certificate"
                  loading="lazy"
                />

                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  className="Becomecaredelete_img"
                  onClick={() => {
                    removeFile("certificate");
                    setvaliderror("");
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="11"
                    cy="11"
                    r="10.5"
                    fill="#FF3868"
                    stroke="white"
                  />
                  <path d="M15 7L7 15" stroke="white" stroke-linecap="round" />
                  <path d="M15 15L7 7" stroke="white" stroke-linecap="round" />
                </svg>
              </div>
            ) : (
              <div>
                <label htmlFor="certificate">
                  <div className="becamecare_uploadbtn">
                    <img
                      src={uploadimg}
                      alt="uploading"
                      className="Becomecareprofile_img"
                      loading="lazy"
                    />
                    <p>
                      <span>Browse</span> or Drag and drop here
                    </p>
                  </div>
                </label>
                <input
                  type="file"
                  id="certificate"
                  accept="image/*"
                  onChange={(e) => {
                    handleFileChange(e, "certificate");
                    setvaliderror("");
                  }}
                  name="certificate"
                />
              </div>
            )}
          </div>
          {validerror !== null ? (
            <div className="validation_error" style={{ margin: "2px 0" }}>
              {validerror}
            </div>
          ) : null}

          <button
            className="Bookcaregiver_button"
            onClick={validate}
            disabled={load}
          >
            {load ? "Loading....." : "Submit"}
          </button>
        </div>
      </div>
      {load && <Loader />}
      <KYCPopup isOpen={kyc} setisOpen={setkyc} url={url} />
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="success">
          {success}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={3000}
        onClose={() => setOpen2(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="error">
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Documents;
